/* =Masonry js
 ----------------------------------------------- */
(function ($) {

    // Default masonry grid
    const masonry = $('.masonry');
    if (masonry.length > 0) {
        // Initialise masonry
        masonry.prepend('<div class="masonry-column"></div><div class="masonry-gutter"></div>');
        masonry.masonry({
            itemSelector: '.masonry-item',
            columnWidth: '.masonry-column',
            gutter: '.masonry-gutter',
            percentPosition: true
        });

        // Trigger updated when images are ready
        masonry.imagesLoaded(() => {
            setTimeout(() => masonry.masonry('layout'), 50);
        });
    }

    // Setup pretty select boxes and update faux sort
    const supplierResults = $('.supplier-results');
    const fauxSelectBox = $('.supplier-search .faux-supplier-sort');

    if (supplierResults.length > 0 && fauxSelectBox.length > 0) {
        const selectBox = $('.supplier-filters select').selectize();
        // Handle updating the faux select within the search form
        selectBox.on('change', (e) => {
            const selected = selectBox[0].selectize.getValue();
            fauxSelectBox.find('option').attr('selected', false);
            fauxSelectBox.find(`option[value=${selected}]`).attr('selected', true);
            fauxSelectBox.trigger('change');
            // Re-Submit the form
            setTimeout(() => $('.supplier-search .wpv-filter-form').submit(), 50);
        });
    }

})(jQuery);
